import React, { useState } from 'react';
import { trackPixel } from '../utils/pixel';
const faqs = [{
  question: '¿Cómo recibo el Megapack después de comprar?',
  answer: 'En el momento en que confirmás el pago recibís un mail con el acceso a todos los materiales. Todo es digital y lo podés abrir desde el celular, la tablet o la computadora en menos de 5 minutos.'
}, {
  question: '¿Sirve si trabajo sola en gabinete privado?',
  answer: 'Está pensado principalmente para profesionales independientes. Todo el sistema de cobro, informes y seguimiento está diseñado para que lo manejés vos sola. Si trabajás en un centro también lo podés aplicar.'
}, {
  question: '¿Sirve si soy recién recibida con poca experiencia?',
  answer: 'Es ideal para eso. Todo está explicado con criterio clínico pero en lenguaje claro y aplicable desde el primer día. Te da el marco para trabajar con seguridad aunque estés empezando.'
}, {
  question: '¿Funciona para todas las edades de 0 a 36 meses?',
  answer: 'Sí. Los 6 tomos están organizados por franjas etarias desde los 0 hasta los 36 meses. Cada tomo tiene sesiones, hitos esperados y alertas específicas para esa etapa.'
}, {
  question: '¿Qué pasa si atiendo niños con diagnóstico o en evaluación?',
  answer: 'El Tomo 4 tiene el semáforo de alertas y criterios de derivación. No reemplaza el juicio clínico, pero te da un marco para identificar señales, documentarlas y hablar con las familias con seguridad.'
}, {
  question: '¿Qué diferencia tiene con otros materiales de ET del mercado?',
  answer: 'La mayoría son teóricos o académicos. Este sistema está diseñado para la práctica real: sesiones planificadas, documentos para familias, sistema de cobro y comunicación. No es un libro — es una caja de herramientas lista para trabajar.'
}, {
  question: '¿Tiene garantía real?',
  answer: 'Sí. Tenés 7 días desde la compra para revisarlo todo. Si no es lo que esperabas te devolvemos el 100% sin preguntas, sin formularios y sin drama. La tasa de devolución es menor al 1%.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900" style={{
    background: 'linear-gradient(180deg, rgb(255,255,255) 0%, rgb(224,242,254) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-138">
      <div className="mx-auto max-w-4xl" data-id="element-139">
        {/* Heading */}
        <h2 className="text-3xl font-black text-center text-gray-900 m-0 mb-2" data-id="element-140">
          Preguntas{' '}
          <span style={{
          color: '#00b4d8'
        }} data-id="element-141">
            frecuentes
          </span>
        </h2>
        <p className="text-center text-sm text-gray-500 m-0 mb-8" data-id="element-142">
          Todo lo que necesitás saber antes de decidir.
        </p>

        {/* Accordion */}
        <div className="flex flex-col gap-2" data-id="element-143">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className="bg-white rounded-xl overflow-hidden shadow-sm transition-all" style={{
            border: isOpen ? '1px solid rgba(0, 180, 216, 0.5)' : '1px solid rgba(0, 180, 216, 0.15)'
          }} data-id="element-144">
                <button onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-3 text-left bg-transparent cursor-pointer border-0 px-5 py-4 m-0" style={{
              fontFamily: 'inherit'
            }} data-id="element-145">
                  <span className="text-sm font-bold" style={{
                color: isOpen ? '#00b4d8' : '#111827'
              }} data-id="element-146">
                    {i + 1}. {faq.question}
                  </span>
                  <span className="shrink-0 w-6 h-6 rounded-full flex items-center justify-center text-white text-base font-black transition-transform duration-300" style={{
                backgroundColor: '#00b4d8',
                transform: isOpen ? 'rotate(45deg)' : 'rotate(0deg)'
              }} data-id="element-147">
                    +
                  </span>
                </button>

                {isOpen && <div className="px-5 pb-4" style={{
              borderTop: '1px solid rgba(0, 180, 216, 0.1)'
            }} data-id="element-148">
                    <p className="text-sm text-gray-600 leading-relaxed m-0 pt-3" data-id="element-149">
                      {faq.answer}
                    </p>
                  </div>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}